import { render } from "./ReviewPositionTable.vue?vue&type=template&id=4bc016fd&ts=true"
import script from "./ReviewPositionTable.ts?vue&type=script&lang=ts&external"
export * from "./ReviewPositionTable.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__